import React, { useState } from 'react';

const Icon = ({ name, onClick, isClaimed }) => {
  const [isClicked, setIsClicked] = useState(isClaimed);

  const handleClick = () => {
    setIsClicked(!isClicked);
    if (onClick) {
      onClick();
    }
  };

  const iconClassName = `text-white rounded-full flex content-center items-center justify-center h-16 w-16 sm:h-20 sm:w-20 xl:h-24 xl:w-24 ${
    isClicked ? 'bg-red' : 'bg-light-green'
  }`;

  return (
    <button onClick={handleClick} className={iconClassName}>
      <i className={`${name} text-3xl sm:text-4xl xl:text-5xl`}></i>
    </button>
  );
};

export default Icon;
